// extracted by mini-css-extract-plugin
module.exports = {"articleContainer":"BlogArticle-module--articleContainer--2_gR3","subtitle":"BlogArticle-module--subtitle--3DZUY"};